import { gql } from "__generated__/gql";
import { useAdminQuery } from "utils/apollo/hooks/admin";
import { assertPresence } from "utils/assertions";
import ReverseMappings from "components/Shared/ReverseMappings";
import {
  ANALYTICS_MAPPING_PRODUCTS,
  analyticsMappingProductsPage,
} from "utils/links";

const query = gql(/* GraphQL */ `
  query ProductReverseMappings($skuId: UUID!) {
    dataSourceTypeColumnValueSkuComponentMappingsList(
      filter: { skuComponent: { skuId: { equalTo: $skuId } } }
      orderBy: CREATED_AT_ASC
    ) {
      id
      columnValue {
        id
        ...ReverseMappingsFragment
      }
    }
  }
`);

type Props = {
  skuId: UUID | null | undefined;
};

export default function ProductMappings({ skuId }: Props) {
  const { data, loading } = useAdminQuery(query, {
    skip: !skuId,
    variables: skuId ? { skuId } : undefined,
    fetchPolicy: "cache-and-network",
  });

  return (
    <ReverseMappings
      columnValues={data?.dataSourceTypeColumnValueSkuComponentMappingsList?.map(
        (m) => {
          assertPresence(m.columnValue);
          return m.columnValue;
        },
      )}
      getMappingPageLinkForType={(dst) =>
        `${analyticsMappingProductsPage(
          dst,
        )}&mapping__skuComponent__sku__sku=${skuId}`
      }
      isLoading={loading}
      mappingPageLink={ANALYTICS_MAPPING_PRODUCTS}
    />
  );
}
